import { TActions } from '../../../AppModulesWrapper';

import { JOIN_FAIR_PLAY_START, JOIN_FAIR_PLAY_SUCCESS, JOIN_FAIR_PLAY_FAIL } from '../../actions/fairPlay';
import { RESET_STATE } from '../../actions/resetState';
import { IFairPlayState, EFairPlayStatus } from '../../types/reducers/fairPlay';

export const defaultState: IFairPlayState = {
  status: EFairPlayStatus.initial,
  errorCode: null,
  error: null,
};

export function fairPlay(state: IFairPlayState = defaultState, action: TActions): IFairPlayState {
  switch (action.type) {
    case JOIN_FAIR_PLAY_START: {
      return {
        ...state,
        status: EFairPlayStatus.pending,
        errorCode: null,
        error: null,
      };
    }

    case JOIN_FAIR_PLAY_SUCCESS: {
      return {
        ...state,
        status: EFairPlayStatus.success,
      };
    }

    case JOIN_FAIR_PLAY_FAIL: {
      const { errorCode, error } = action.payload;

      return {
        ...state,
        status: EFairPlayStatus.fail,
        errorCode,
        error,
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
